import { computed, ref, watch } from "vue";
// import AvailableDates from "src/composables/AvailableDates";
import { useSessionStorage } from "vue-composable";
import Analytics from "src/composables/Analytics";

const { log_event } = Analytics();
// const { get_available_dates, available_dates } = AvailableDates();

const { storage: selected_plan } = useSessionStorage('selected_plan', null)

const is_rhythm = computed(() => selected_plan.value?.product?.brand?.name === 'Rhythm Energy');

const is_just_energy = computed(() => {
  return ['Just Energy', 'Amigo Energy', 'Tara Energy'].includes(selected_plan.value?.product?.brand?.name)
})

const is_apge = computed(() => {
  return ['APGE'].includes(selected_plan.value?.product?.brand?.name)
})

const is_txu_energy = computed(() => {
  return ['TXU Energy'].includes(selected_plan.value?.product?.brand?.name)
})

const is_nextera = computed(() => {
  return ['Gexa Energy', 'Frontier Utilities'].includes(selected_plan.value?.product?.brand?.name)
})

const is_Constellation = computed(() => {
  return ['Constellation'].includes(selected_plan.value?.product?.brand?.name)
})

const is_plan_valid = computed(() => !!selected_plan.value)
const plan_position = ref(null);
const featured_plan_position = ref(null);

watch(selected_plan, async () => {
  // log_event({ name: 'mv_plan_selected', plan: selected_plan.value })

  // if (selected_plan.value?.product?.brand?.name && selected_plan.value?.tdsp?.duns_number) {
  //     available_dates.value = await get_available_dates({
  //         brand: selected_plan.value.product.brand.name,
  //         duns_number: selected_plan.value.tdsp.duns_number
  //     })
  // }
})

export default () => {
  return {
    selected_plan,
    is_apge,
    is_rhythm,
    is_just_energy,
    is_txu_energy,
    is_nextera,
    is_Constellation,
    is_plan_valid,
    featured_plan_position,
    plan_position
  }
}
